import { AnalyticsInstance } from 'analytics';

import { createAnalyticsInstance } from '../functions/createAnalyticsInstance';

export const analytics: AnalyticsInstance = createAnalyticsInstance();
